import { MethodType } from '../constants/MethodType'

const api = require('./api')

export const fetchDashboardData = params => api.request(1, '/getDashboardDatas', MethodType.POST, params)

export const refreshDashboardData = params => api.request(1, '/updateDashboardData', MethodType.POST, params)

export const downloadDashboardData = params => api.request(1, '/downloadDashboardData', MethodType.POST, params, {}, false, { responseType: 'blob' })

// ----- Setting ----- //
export const fetchDashboardSetting = params => api.request(1, '/dashboardSettings', MethodType.GET, params)

export const addDashboardSetting = params => api.request(1, '/dashboardSettings', MethodType.POST, params)

export const modDashboardSetting = (id, params) => api.request(1, `/dashboardSettings/${id}`, MethodType.PUT, params)

export const delDashboardSetting = (id, brandId, params) => api.request(1, `/dashboardSettings/${id}`, MethodType.DELETE, params)

export const modDashboardSettingPosition = params => api.request(1, '/dashboardSettingPositionBulkModify', MethodType.PATCH, params)

// ----- Consumer 360 ----- //
export const addConsumerSetting = params => api.request(1, '/addConsumer360DashboardSetting', MethodType.POST, params)

export const modConsumerSetting = (id, params) => api.request(1, `/modConsumer360DashboardSetting/${id}`, MethodType.PUT, params)

export const delConsumerSetting = (id, brandId, params) => api.request(1, `/delConsumer360DashboardSetting/${brandId}/${id}`, MethodType.DELETE, params)

// ----- Site Chart ----- //
export const fetchSiteBrand = (groupId, brandId, params) => api.request(1, `/getBrandSites/${groupId}/${brandId}`, MethodType.GET, params)

export const fetchSiteCharts = params => api.request(1, '/siteCharts', MethodType.GET, params)

export const modSiteChartEnable = (brandId, params) => api.request(1, `/setSiteChartEnable/${brandId}`, MethodType.PUT, params)

// ----- Cross Data ----- //
export const fetchDataSourceTree = (brandId, params) => api.request(1, `/dataSourceTree/${brandId}`, MethodType.GET, params)

export const fetchCrossDataPreview = params => api.request(1, '/crossDataSourcePreview', MethodType.POST, params)

// ----- Indicators ----- //
export const fetchIndicators = (brandId, dimensionId, params) => api.request(1, `/getIndicators/${brandId}/${dimensionId}`, MethodType.GET, params)
